import {
  Box,
  Button,
  Divider,
  Grid2,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Logo from '../assets/logo.png';
import { theme } from '../utils/theme/Theme';
import Iconify from './Iconify';

function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const xs = useMediaQuery('(min-width:700px)');
  const sm = useMediaQuery('(min-width:900px)');
  const lg = useMediaQuery('(min-width:1400px)');

  return (
    <Box
      backgroundColor={theme.colors.primary}
      paddingX={lg ? 30 : sm ? 20 : 4}
      paddingTop={6}
      paddingBottom={1}
    >
      <Grid2 container columnSpacing={4} rowSpacing={4}>
        <Grid2 size={{ md: 12, lg: 6 }}>
          <Box
            component={'img'}
            src={Logo}
            alt='Logo'
            width={'50%'}
            onClick={() => navigate('/')}
            sx={{ cursor: 'pointer' }}
          />
          <Typography
            sx={{
              color: 'white',
              paddingY: 2,
              fontSize: 18,
              maxWidth: sm ? '80%' : '100%',
            }}
          >
            {t('footer.description')}
          </Typography>
          <Box display={'flex'}>
            <Box
              display={'flex'}
              alignItems={'center'}
              backgroundColor={theme.colors.secondary}
              padding={1.5}
              borderRadius={1}
              marginInlineEnd={1}
              onClick={() =>
                window.open(
                  'https://www.facebook.com/Dr.Ali.Al.Heneiti',
                  '_blank'
                )
              }
              sx={{ cursor: 'pointer' }}
            >
              <Iconify
                icon={'uil:facebook'}
                sx={{ fontSize: 20, color: theme?.colors?.primary }}
              />
            </Box>
            <Box
              display={'flex'}
              alignItems={'center'}
              backgroundColor={theme.colors.secondary}
              padding={1.5}
              borderRadius={1}
              onClick={() =>
                window.open(
                  'https://www.instagram.com/ali_alheneiti/',
                  '_blank'
                )
              }
              sx={{ cursor: 'pointer' }}
            >
              <Iconify
                icon={'simple-icons:instagram'}
                sx={{ fontSize: 20, color: theme?.colors?.primary }}
              />
            </Box>
          </Box>
        </Grid2>
        <Grid2 size={{ md: 12, lg: 6 }} width={'100%'}>
          <Typography
            sx={{
              fontSize: 28,
              fontWeight: 'bold',
              color: 'white',
              marginBottom: 2,
            }}
          >
            {t('footer.location')}
          </Typography>
          <iframe
            title='Dr-Ali'
            src='https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3384.937829186638!2d35.86775!3d31.9625833!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzHCsDU3JzQ1LjMiTiAzNcKwNTInMDMuOSJF!5e0!3m2!1sen!2ssa!4v1733848172973!5m2!1sen!2ssa'
            width='100%'
            height={sm ? 350 : 250}
            style={{ border: 0 }}
            loading='lazy'
          />
        </Grid2>
      </Grid2>
      <Divider sx={{ borderColor: 'white', marginTop: 4, marginBottom: 0 }} />
      <Box
        display={'flex'}
        flexDirection={xs ? 'row' : 'column'}
        justifyContent={xs ? 'space-between' : 'center'}
        alignItems={'center'}
        marginTop={!xs && 2}
      >
        <Typography
          sx={{
            color: 'white',
            fontSize: 16,
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          {t('footer.copyright')}
        </Typography>

        <Box>
          <Button
            disableRipple
            onClick={() => navigate('/')}
            sx={{
              padding: 2,
              fontSize: 16,
              color: 'white',
              '&:hover': { backgroundColor: 'transparent', color: 'white' },
            }}
          >
            {t('footer.links.home')}
          </Button>
          <Button
            disableRipple
            onClick={() => navigate('/About')}
            sx={{
              padding: 2,
              fontSize: 16,
              color: 'white',
              '&:hover': { backgroundColor: 'transparent', color: 'white' },
            }}
          >
            {t('footer.links.about')}
          </Button>
          <Button
            disableRipple
            onClick={() => navigate('/ContactUs')}
            sx={{
              padding: 2,
              fontSize: 16,
              color: 'white',
              '&:hover': { backgroundColor: 'transparent', color: 'white' },
            }}
          >
            {t('footer.links.contact')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default Footer;
